import React, { useEffect } from "react";
import ReactGA from "react-ga";
import CookieConsent from "../components/CookieConsent";
import Footer from "../components/Footer";
import Header from "../components/Header";
import styled from "styled-components";
import { lighten } from "polished";
import CharityIcon from "../components/svg/CharityIcon";
import RightArrowIcon from "../components/svg/RightArrowIcon";
import NetworkIcon from "../components/svg/NetworkIcon";
import HelpIcon from "../components/svg/HelpIcon";

function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    ReactGA.pageview(window.location.pathname + window.location.search);
  });

  return (
    <Container>
      <Header />
      <Main>
        <Hero>
          Corona Hilfe Wegweiser ist ein kostenloses globales Netzwerk, das
          Helfer und Hilfesuchende im Zusammenhang mit dem Ausbruch von COVID-19
          miteinander verbindet.
        </Hero>
        <Actions>
          <Action color="rgb(99, 169, 78)">
            <div>Ich benötige Hilfe!</div>
            <IconContainer>
              <StyledHelpIcon />
              <StyledArrowIcon />
            </IconContainer>
          </Action>
          <Action color="rgb(182, 57, 63)">
            <div>Ich möchte helfen!</div>
            <IconContainer>
              <StyledCharityIcon />
              <StyledArrowIcon />
            </IconContainer>
          </Action>
          <Action color="rgb(128, 100, 78)">
            <div>Initiative anmelden!</div>
            <IconContainer>
              <StyledNetworkIcon />
              <StyledArrowIcon />
            </IconContainer>
          </Action>
        </Actions>
      </Main>
      <Footer />
      <CookieConsent />
    </Container>
  );
}

export default Home;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 6rem 3rem;
  flex-grow: 1;
`;

const Hero = styled.div`
  align-self: center;
  font-size: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  padding: 4rem 0rem;
  max-width: 480px;
`;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  & > :not(:last-child) {
    margin-right: 2rem;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;

    & > :not(:last-child) {
      margin-right: 0rem;
      margin-bottom: 3rem;
    }
  }
`;

const Action = styled.a<{ color: string }>`
  background-color: ${p => p.color};
  color: white;
  font-size: 1.1rem;
  border-radius: 6px;
  padding: 1.5rem 3rem;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  transition: background-color 0.3s ease-in-out, transform 0.2s ease-in-out;
  font-weight: 600;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: ${p => lighten(0.05, p.color)};
      transform: scale(1.01);
    }
  }
`;

const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 0.5rem;
`;

const StyledCharityIcon = styled(CharityIcon)`
  height: 2rem;
  padding-right: 2rem;
  fill: white;
`;

const StyledNetworkIcon = styled(NetworkIcon)`
  height: 2rem;
  padding-right: 2rem;
  fill: white;
`;

const StyledHelpIcon = styled(HelpIcon)`
  height: 2rem;
  padding-right: 2rem;
  fill: white;
`;

const StyledArrowIcon = styled(RightArrowIcon)`
  height: 2rem;
  fill: white;
`;
